import { useEffect, useState } from "react";
import { Search, Send, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { errMsg } from "@/lib/api";

const money = (c, cur) => `$${(c / 100).toFixed(2)} ${cur.toUpperCase()}`;

export const AdminInvoices = ({ api }) => {
  const [q, setQ] = useState("");
  const [rows, setRows] = useState(null);
  const [sending, setSending] = useState(null);

  useEffect(() => {
    const t = setTimeout(() => api.get("/admin/invoices", { params: { q } }).then((r) => setRows(r.data)).catch((e) => toast.error(errMsg(e))), 300);
    return () => clearTimeout(t);
  }, [q, api]);

  const resend = async (inv) => {
    setSending(inv.number);
    try {
      const { data } = await api.post(`/admin/invoices/${inv.number}/resend`);
      toast.success(`Invoice ${inv.number} resent to ${data.sent_to}`);
    } catch (e) { toast.error(errMsg(e, "Could not resend")); }
    finally { setSending(null); }
  };

  return (
    <section data-testid="admin-invoices">
      <div className="mt-14 flex flex-wrap items-end justify-between gap-4">
        <h2 className="text-2xl text-ink">Invoices</h2>
        <div className="relative w-full max-w-xs">
          <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-taupe" />
          <Input className="field pl-9" placeholder="Search invoice number or email" value={q} onChange={(e) => setQ(e.target.value)} data-testid="admin-invoice-search" />
        </div>
      </div>
      <div className="mt-4 overflow-x-auto rounded-xl border border-paper-border bg-white">
        <Table data-testid="admin-invoices-table">
          <TableHeader><TableRow><TableHead /><TableHead>Invoice</TableHead><TableHead>Customer</TableHead><TableHead>Date</TableHead><TableHead>Total</TableHead><TableHead>GST</TableHead></TableRow></TableHeader>
          <TableBody>
            {rows && rows.length === 0 && <TableRow><TableCell colSpan={6} className="py-8 text-center text-ink-soft">No invoices found.</TableCell></TableRow>}
            {(rows || []).map((inv) => (
              <TableRow key={inv.number} data-testid={`admin-invoice-row-${inv.number}`}>
                <TableCell>
                  <button className="btn-ink whitespace-nowrap !px-3 !py-1.5 !text-xs" onClick={() => resend(inv)} disabled={!!sending || !inv.customer_email} data-testid={`admin-invoice-resend-${inv.number}`}>
                    {sending === inv.number ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Send className="h-3.5 w-3.5" />} Resend
                  </button>
                </TableCell>
                <TableCell className="whitespace-nowrap font-mono text-xs">{inv.number}</TableCell>
                <TableCell>{inv.customer_email || "—"}</TableCell>
                <TableCell className="text-ink-soft">{inv.date_display}</TableCell>
                <TableCell>{money(inv.total_cents, inv.currency)}</TableCell>
                <TableCell className="text-ink-soft">{money(inv.gst_cents, inv.currency)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </section>
  );
};
